module.exports = __webpack_public_path__ + "static/media/banner.126ddf4d.jpg";